import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/Header';
import { SettingsList } from '../components/SettingsList';

export const Settings = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box h={'66px'}>
        <Header headerText={t('settings')} showBurger={false} />
      </Box>

      <Box mx={'21px'}>
        <SettingsList />
      </Box>
    </>
  );
};
